<template>
  <card
    page="login"
    style="overflow:visible;">
    <label class="top-label">TELL US ABOUT YOURSELF</label>
    <form-component>
      <form
        id="step-one"
        data-vv-scope="step-one"
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <label>When is your birthday?</label>
        <div
          class="form-row hide-label"
          :class="{'form-wrapper__error': errors.has('step-one.month') || errors.has('step-one.day') || errors.has('step-one.year') }"
        >
          <div class="col-12 col-md-4">
            <input-select
              id="month"
              v-model="month"
              v-validate="'required'"
              name="month"
              data-vv-name="month"
              data-vv-as="month"
              label="Month"
              type="select"
              placeholder="Month"
              required
              :error="errors.first('step-one.month')"
              :options="monthOptions"
              :hide-error-label="true"
            />
          </div>
          <div class="col-12 col-md-4">
            <input-select
              id="day"
              v-model="day"
              v-validate="'required'"
              name="day"
              data-vv-name="day"
              data-vv-as="day"
              label="Day"
              type="select"
              placeholder="Day"
              required
              :error="errors.first('step-one.day')"
              :options="dayOptions"
              :hide-error-label="true"
            />
          </div>
          <div class="col-12 col-md-4">
            <input-select
              id="year"
              v-model="year"
              v-validate="'required'"
              name="year"
              data-vv-name="year"
              data-vv-as="year"
              label="Year"
              type="select"
              placeholder="Year"
              required
              :error="errors.first('step-one.year')"
              :options="yearOptions"
              :hide-error-label="true"
            />
          </div>
          <div class="col-12">
            <p
              v-show="errors.has('step-one.month') || errors.has('step-one.day') || errors.has('step-one.year')"
              class="form__error"
            >
              The birthday field is required
            </p>
          </div>
        </div>

        <label>What is your gender identity?</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <gender-select
              id="gender"
              v-model="gender"
              v-validate="'required'"
              name="gender"
              data-vv-name="gender"
              data-vv-as="gender"
              label="gender"
              :select-options="studentGenderOptions"
              required
              :error="errors.first('step-one.gender')"
            />
          </div>
        </div>
        <label>What is your ethnicity?</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <ethnicity-select
              id="ethnicity"
              v-model="ethnicity"
              v-validate="'required'"
              name="ethnicity"
              data-vv-name="ethnicity"
              data-vv-as="ethnicity"
              label="ethnicity"
              required
              :error="errors.first('step-one.ethnicity')"
            />
          </div>
        </div>

        <label>Where are you currently located?</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <input-type-ahead
              v-validate="'required'"
              :list="cities"
              :value="currentCity"
              :searchchange="getCities"
              :selected-value="selectedCity"
              option-value="id"

              option-text="display_name"
              data-vv-name="currentCity"
              data-vv-as="Current Location"
              required

              label="Current Location"
              placeholder="Type a city name..."
            />

            <p
              v-show="errors.first('step-one.currentCity')"
              class="form__error"
            >
              {{ errors.first('step-one.currentCity') }}
            </p>
          </div>
        </div>

        <label>What is your phone number?</label>
        <input-text
          id="phone"
          v-model="phone"
          v-validate="'required'"
          name="phone"
          data-vv-name="phone"
          data-vv-as="phone number"
          label=""
          type="number"
          required
          :error="errors.first('step-one.phone')"
        />

        <div class="col-12">
          <input
            id="allow_sms_notifications"
            v-model="allow_sms_notifications"
            name="allow_sms_notifications"
            type="checkbox"
          >
          <label for="allow_sms_notifications">
            Would you like to receive text message reminders about your upcoming sessions?
          </label>
        </div>

        <div class="row mt-30">
          <div class="col-12 col-md-6 order-md-2">
            <button
              class="btn btn--primary mt-30"
              :disabled="saving"
              type="submit"
            >
              <font-awesome-icon
                v-if="saving"
                :spin="true"
                :icon="['fas', 'spinner']"
                class="icon alt"
              />
              <span v-else>Continue</span>
            </button>
          </div>
          <div class="col-12 col-md-6 order-md-1" />
        </div>
      </form>
    </form-component>
  </card>
</template>

<script>
import UserClient from '@/api/UserClient';
import StudentClient from '@/api/StudentClient';
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
import EthnicitySelect from '@/components/inputs/EthnicitySelect.vue';
import GenderSelect from '@/components/inputs/GenderSelect.vue';
import moment from 'moment';
import genderOptions from '@/helpers/mixins/gender-options';
import Card from '@/components/Card.vue';

export default {
  components: {
    Card,
    FormComponent,
    InputText,
    InputSelect,
    InputTypeAhead,
    EthnicitySelect,
    GenderSelect
  },
  mixins: [genderOptions],
  data() {
    return {
      userClient: new UserClient(this.$http),
      studentClient: new StudentClient(this.$http),
      saving: false,

      year: '',
      month: '',
      day: '',

      phone: '',

      cities:[],
      currentCity: null,
      _getCitiesTimeout: null,

      gender: '',
      ethnicity: '',
      allow_sms_notifications: false,

      dayOptions: [
        { id: 1, display_label: '01' },
        { id: 2, display_label: '02' },
        { id: 3, display_label: '03' },
        { id: 4, display_label: '04' },
        { id: 5, display_label: '05' },
        { id: 6, display_label: '06' },
        { id: 7, display_label: '07' },
        { id: 8, display_label: '08' },
        { id: 9, display_label: '09' },
        { id: 10, display_label: '10' },
        { id: 11, display_label: '11' },
        { id: 12, display_label: '12' },
        { id: 13, display_label: '13' },
        { id: 14, display_label: '14' },
        { id: 15, display_label: '15' },
        { id: 16, display_label: '16' },
        { id: 17, display_label: '17' },
        { id: 18, display_label: '18' },
        { id: 19, display_label: '19' },
        { id: 20, display_label: '20' },
        { id: 21, display_label: '21' },
        { id: 22, display_label: '22' },
        { id: 23, display_label: '23' },
        { id: 24, display_label: '24' },
        { id: 25, display_label: '25' },
        { id: 26, display_label: '26' },
        { id: 27, display_label: '27' },
        { id: 28, display_label: '28' },
        { id: 29, display_label: '29' },
        { id: 30, display_label: '30' },
        { id: 31, display_label: '31' },
      ],
      monthOptions: [
        { id: 1, display_label: '01' },
        { id: 2, display_label: '02' },
        { id: 3, display_label: '03' },
        { id: 4, display_label: '04' },
        { id: 5, display_label: '05' },
        { id: 6, display_label: '06' },
        { id: 7, display_label: '07' },
        { id: 8, display_label: '08' },
        { id: 9, display_label: '09' },
        { id: 10, display_label: '10' },
        { id: 11, display_label: '11' },
        { id: 12, display_label: '12' },
      ],
      yearOptions: [],
    }
  },
  beforeMount() {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i <= 100; i++) {
      this.yearOptions.push({
        id: currentYear - i,
        display_label: currentYear - i
      });
    }
  },
  mounted() {
    const user = this.$store.getters.currentUser;
    this.phone = this.getPhoneValue(user.phone_number || '');
    this.gender = user.gender || '';
    this.ethnicity = user.race || '';

    if (user.city && user.city.id) {
      this.cities = [user.city];
      this.currentCity = user.city.id;
    }
  },
  methods: {
    async save() {
      const result = await this.$validator.validateAll('step-one');
      if (!result) { return; }

      this.errors.clear();

      const phone = this.phone.replace(/[^\d.]/g, '');

      if (phone.length > 0 && phone.length !== 10) {
        return this.$store.commit('setGlobalAlert', {
          msg: 'Please enter your full phone number. For example, (585)123-1234', error: true,
        });
      }

      const dob = `${this.year}-`
                + `${this.month > 9 ? this.month : `0${this.month}`}-`
                + `${this.day > 9 ? this.day : `0${this.day}`}`;

      if (moment().diff(dob, 'years') < 18) {
        return this.$store.commit('setGlobalAlert', {
          msg: 'BetterMynd is only available for those who are at least 18 years of age.',
          error: true,
        });
      }

      this.saving = true;
      try {
        const response = await this.userClient.saveWelcomeStepOne(
          dob,
          this.currentCity,
          this.gender,
          this.ethnicity === 'preferNotToAnswer' ? null : this.ethnicity,
          phone,
          this.allow_sms_notifications)

        const user = this.$store.getters.currentUser;
        user.storeWelcomeStepOneData(response);

        await this.studentClient.updatePreferences(user.id)

        this.$emit('complete', null);
      } catch (ex) {
        this.handleException(ex);
      } finally {
        this.saving = false;
      }
    },
    handleException(ex) {
      console.error(ex);
      let errorMessage = 'Failed to save. Please try again!';

      if (ex && ex.body && ex.body.error && ex.body.error) {
        const { error } = ex.body
        if (error.extra && error.extra.detail) {
          errorMessage = ex.body.error.extra.detail;
        } else if (error.message) {
          errorMessage = ex.body.error.message;
        }
      }

      this.$store.commit('setGlobalAlert', {
        msg: errorMessage, error: true,
      });
    },
    getPhoneValue(phone) {
      if (phone.length > 10) {
        // trim off the +1 b/c form expects 10 digits
        return phone.substr(phone.length - 10, 10);
      }
      return phone;
    },
    getCities(query, done) {
      if (this.currentCity && !query) {
        // we just selected one, do not empty the results
        return;
      }

      if (this._getCitiesTimeout) {
        clearTimeout(this._getCitiesTimeout);
        this._getCitiesTimeout = null;
      }

      this._getCitiesTimeout = setTimeout(
        this.fillCities,
        300,
        this.userClient,
        this.cities,
        query);
    },
    selectedCity(v) {
      this.currentCity = v;
    },
    async fillCities(userClient, cities, query) {
      try {
        cities.length = 0;
        const response = await userClient.getCityList(query);
        if (response.results) { cities.push(...response.results); }
      } catch (ex) {
        console.error(ex);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
input[type=checkbox] {
  position: absolute;
  left: 20px;
  top: 5px;
  width: 20px;
  height: 20px;
}
input[type=checkbox] + label {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  font-size: 16px;
  line-height: 20px;
  margin: 5px;
}
input[type=checkbox] + label:before {
  line-height: 20px;
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  background-color: $blue;
  border: 1px solid $off-blue;
}
input[type=checkbox]:checked + label:before {
  content: "\2713";
  color: $green;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  cursor: pointer;
}
input[type=checkbox] + label:hover {
  cursor: pointer;
}
input[type=checkbox] + label:active:before {
  content: "\26F6";
  color: $off-blue;
  text-align: center;
  line-height: 16px;
}
</style>
